module.exports = __webpack_public_path__ + "static/media/hangman_3.b2f66150.svg";